export default __webpack_public_path__ + "static/media/search-md-past-consultation.3f5746c3.svg";